.order {
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.titleOrder {
  margin-right: 10px;
}

.icon {
  cursor: pointer;
  user-select: none;

  &.isAsc {
    transform: rotateX(180deg);
  }
}

.radioBtn {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
